import store from '../store/store'
import UserApi from '../misc/apis/UserApi'
import { connect } from 'getstream'
import { reportGetStreamError } from '../misc/utils/getStreamSentry'

const notification = {
  data() {
    return {
      streamClient: null
    }
  },
  methods: {
    async loadGetStreamio() {
      if (!store.getters['notification/getToken']) {
        try {
          let response
          try {
            response = await UserApi.getNotificationToken(store.getters['user/getUserId'])
          } catch {
            response = await UserApi.getNotificationToken(store.getters['user/getUserId'])
          }
          await store.dispatch('notification/setToken', response.token)
          this.streamClient = connect(process.env.VUE_APP_GET_STREAM_APP_KEY, response.token, process.env.VUE_APP_GET_STREAM_APP_ID, { location: 'eu-west', timeout: 15000 })
        } catch (e) {
          reportGetStreamError(e, 'getNotificationToken', { retried: true })
        }
      } else {
        this.streamClient = connect(process.env.VUE_APP_GET_STREAM_APP_KEY, store.getters['notification/getToken'], process.env.VUE_APP_GET_STREAM_APP_ID, { location: 'eu-west', timeout: 15000 })
      }
    }
  }
}

export { notification }
